import WStepBusinessGoals from "./WStepBusinessGoals.jsx";
import WStepBusinessType from "./WStepBusinessType.jsx";
import WStepECommerceBusinessGoal from "./WStepECommerce/WStepECommerceBusinessGoals.jsx";
import WStepECommerceDetails from "./WStepECommerce/WStepECommerceDetails.jsx";
import WStepLocalisation from "./WStepLocalisation.jsx";

const PartProductType = {
    key: "product-type",
    t_wizardMenu: "WizardMenuBusinessType",
    component: WStepBusinessType,
    requires: ["ProductType"],
};

const PartBusinessGoal = {
    key: "business-goal",
    t_wizardMenu: "WizardMenuBusinessGoals",
    component: WStepBusinessGoals,
    requires: ["BusinessGoal"],
};

const PartLocalisation = {
    key: "localisation",
    t_wizardMenu: "WizardMenuLocalisation",
    component: WStepLocalisation,
    requires: ["Localisation"],
    isLast: true,
};

const PartECommerceBusinessGoal = {
    key: "ecommerce-business-goal",
    t_wizardMenu: "WizardMenuBusinessGoals",
    component: WStepECommerceBusinessGoal,
    requires: ["BusinessGoal"],
};

const PartECommerceDetails = {
    key: "ecommerce-details",
    t_wizardMenu: "WStepECommerceDetails",
    component: WStepECommerceDetails,
    // requires: ["BusinessGoal"],
    requires: [],
};

const PartDesigningLayout = { key: "designing-layout", component: null };

export const PartListInit = [
    //
    PartProductType,
    PartDesigningLayout,
];

export const PartListDefault = [
    //
    PartProductType,
    PartBusinessGoal,
    PartLocalisation,
    PartDesigningLayout,
];

export const PartListECommerce = [
    //
    PartProductType,
    PartECommerceBusinessGoal,
    PartECommerceDetails,
    PartDesigningLayout,
];
